import axios from 'axios'
import axiosRetry, { exponentialDelay, isIdempotentRequestError } from 'axios-retry'

// Retry only for idempotent methods (GET, HEAD, OPTIONS, PUT, DELETE) on
// network errors, 429, or 5xx. Non-idempotent requests (POST) are never
// retried — they would risk duplicate writes (e.g. duplicate ConsentLog
// rows, double-counted impressions) on requests whose response was lost
// in flight.
//
// See https://github.com/softonic/axios-retry
//
const client = axios.create()

axiosRetry(client, {
  retries: 3,
  retryCondition: isIdempotentRequestError,
  retryDelay: exponentialDelay,
})


export default client
